export class Template {
    id:number;
    name: string;
    promoCode: string;
}



// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/common/models/template.ts